import { useEffect, useState, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import React from "react";
import { toast } from "react-toastify";
import { formatDateToShortString, getColorFromSegment } from "../../../../common/common";
import { FaEye, FaCommentDots } from 'react-icons/fa';
import "./rfm.css"
import Kmeans from "./kmeans";
import KmeansClustering from "./kmeansclustering";



const Rfm = React.memo(() => {
    const navigate = useNavigate();
    const location = useLocation();
    const { order_details_id, reportId, start_date, end_date } = location.state || {};

    const [customerSegmentaionsResponse, setCustomerSegmentaionsResponse] = useState([]);
    const [rfmResponse, setRfmResponse] = useState([]);
    const [filterRfmResponse, setFilterRfmResponse] = useState([]);

    const [calendar_insights, setCalendar_insights] = useState({});

    const [isLoading, setIsloading] = useState(false);
    const [activeTab, setActiveTab] = useState("k-means"); // 🟢 tab state

    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const [searchQuery, setSearchQuery] = useState('');
    const [recencyFilter, setRecencyFilter] = useState('');
    const [segmentFilter, setSegmentFilter] = useState('');
    const [recencyComparison, setRecencyComparison] = useState('eq'); // 'eq' | 'lt' | 'gt'
    const [blockValue, setBlockValue] = useState({})

    // const MemoizedKmeans = useMemo(() => <Kmeans />, []);


    const getCustomerSegmentaions = async () => {
        try {
            // setIsloading(true);
            const response = await fetch(
                `${process.env.REACT_APP_CUSTOMER_SEGMETAIONS}?order_details_id=${order_details_id}`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                }
            );

            const dataN = await response.json();
            if (!response.ok) {
                if (dataN.detail?.isExpireToken) {
                    localStorage.removeItem("token");
                    localStorage.removeItem("userInfo");
                    navigate("/login");
                }
                throw new Error(dataN.detail?.message || "Failed to fetch customer segments");
            }
            setCustomerSegmentaionsResponse(dataN.segment_summary);
            let totalRevenue = 0;
            let highestDays = 0;
            let lowestDays = 1000000;
            let totalOrder = 0;
            let highestSpent = 0;
            let highestCust = {};

            const customers = dataN.rfm_scores.map((cust) => {

                totalRevenue += cust.total_spent;
                totalOrder += cust.order_count;

                if (highestDays <= cust.recency_days)
                    highestDays = cust.recency_days

                if (lowestDays >= cust.recency_days)
                    lowestDays = cust.recency_days

                if (highestSpent <= cust.total_spent) {
                    highestSpent = cust.total_spent
                    highestCust = cust
                }

                return ({
                    name: cust.customer_name,
                    email: cust.customerEmail,
                    initials: cust.customer_name?.trim() == "" || cust.customer_name == null ? 'N/A' : cust.customer_name
                        .split(' ')
                        .map((n) => n[0])
                        .join('')
                        .toUpperCase(),
                    color: getColorFromSegment(cust.segment), // You'll define this function below
                    scores: {
                        R: cust.R_score,
                        F: cust.F_score,
                        M: cust.M_score,
                    },
                    recency: `${cust.recency_days} days`,
                    recency_days: cust.recency_days,
                    totalSpent: `$${cust.total_spent.toFixed(2)}`,
                    orders: cust.order_count,
                    segment: cust.segment,
                    segmentColor: getColorFromSegment(cust.segment),
                })
            });

            setRfmResponse(customers)
            setFilterRfmResponse(customers)
            setCalendar_insights(dataN.calendar_insights)
            setBlockValue((old) => {
                return {
                    ...old,
                    totalCustomers: customers.length,
                    totalRevenue,
                    highestDays,
                    lowestDays,
                    totalOrder,
                    highestSpent,
                    highestCust
                }
            })
        } catch (err) {
            toast.error(err.message, {
                position: "top-right",
                autoClose: 3000,
            });
        } finally {
            // setIsloading(false);
        }
    };

    useEffect(() => {
        if (customerSegmentaionsResponse.length === 0) {
            getCustomerSegmentaions();
        }
    }, []);

    useEffect(() => {
        const filterResponse = rfmResponse
            // Text filter: matches name or email (case-insensitive)
            .filter((cust) => {
                if (!searchQuery) return true;
                const nameMatch = cust.name?.toLowerCase().includes(searchQuery.toLowerCase());
                const emailMatch = cust.email?.toLowerCase().includes(searchQuery.toLowerCase());
                return nameMatch || emailMatch;
            })

            // Recency filter: exact match of days (optional)
            .filter((cust) => {
                if (!recencyFilter) return true;
                const value = parseInt(recencyFilter);
                if (isNaN(value)) return true;
                switch (recencyComparison) {
                    case 'lt':
                        return cust.recency_days < value;
                    case 'lte':
                        return cust.recency_days <= value;
                    case 'gt':
                        return cust.recency_days > value;
                    case 'gte':
                        return cust.recency_days >= value;
                    case 'ne':
                        return cust.recency_days !== value;
                    case 'eq':
                    default:
                        return cust.recency_days === value;
                }
            })
            // Segment filter: match selected segment
            .filter((cust) => {
                if (!segmentFilter) return true;

                return cust.segment === segmentFilter;
            })

        setFilterRfmResponse(filterResponse)
        setCurrentPage(1)
    }, [searchQuery, recencyFilter, segmentFilter, recencyComparison])


    const totalPages = Math.ceil(filterRfmResponse.length / itemsPerPage);

    const paginatedData = filterRfmResponse.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );




    if (isLoading) {
        return (
            <div className="flex items-center justify-center h-screen bg-gray-50">
                <div className="flex flex-col items-center">
                    <div className="w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mb-4" />
                    <h1 className="text-xl font-medium text-gray-700">Loading, please wait...</h1>
                </div>
            </div>
        );
    }

    return (

        <main className="w-full mx-auto px-4 py-6 sm:px-6 lg:px-8">
            <div id="analysisContent" className="h-full p-4">
                <div className="flex items-center justify-between gap-3">
                    <div>
                        <h2 className="text-2xl font-bold text-gray-900">
                            Customer Segmentation & Revenue Contribution Analysis For {" - "}

                            Order Report{" "}
                            {reportId}

                        </h2>
                        <div class="flex items-center mt-1 mb-3">
                            <span class="text-sm text-gray-500">
                                <i class="fas fa-calendar-alt mr-1"></i> Orders from{" "}
                                <b>{formatDateToShortString(start_date)}</b> to{" "}
                                <b>{formatDateToShortString(end_date)}</b>
                            </span>
                        </div>
                    </div>
                    <div className="flex space-x-2">
                        <button
                            className="bg-gray-200 text-gray-800 px-4 py-2 rounded-lg text-sm hover:bg-gray-300 transition duration-300"
                            onClick={() => navigate(-1)}
                        >
                            ← Back
                        </button>
                    </div>
                </div>
                {/* 🔘 Tab Buttons */}
                <div className="mb-6 flex space-x-4 border-b">
                    
    
     <button
                        className={`px-4 py-2 font-medium ${activeTab === "k-means"
                            ? "border-b-2 border-blue-500 text-blue-600"
                            : "text-gray-500 hover:text-blue-500"
                            }`}
                        onClick={() => setActiveTab("k-means")}
                    >
                        Customer Segmentation & RFM Analysis
                    </button>
                   


                    
                    <button
                        className={`px-4 py-2 font-medium ${activeTab === "snlt"
                            ? "border-b-2 border-blue-500 text-blue-600"
                            : "text-gray-500 hover:text-blue-500"
                            }`}
                        onClick={() => setActiveTab("snlt")}
                    >
                        Seasonal Trends
                    </button>
                   
                    
                    

                </div>

                {/* ✅ RFM Tab Content */}
                {activeTab === "crm" && (
                    <div className="fade-in config-card p-6 mb-0 cstm_ResultsTest-radius rounded-none">
                        {/* <h3 className="text-lg font-medium text-gray-900 mb-1">Customer Segmentation</h3>
                        <p className="text-sm text-gray-500 mb-4">
                            Customer Segmentation classifies customers into meaningful groups based on engagement, loyalty, and spending patterns.
                        </p> */}
                        <div>
                            <h4 className="font-medium text-gray-900 mb-2">Recommendations</h4>
                            <ul className="list-disc pl-5 space-y-1 text-sm text-gray-700">
                                <li>Offer exclusive deals to Champions to maintain loyalty</li>
                                <li>Create a win-back campaign for At Risk customers</li>
                                <li>Develop a referral program leveraging Loyal Customers</li>
                                <li>Send personalized recommendations to Potential Loyalists</li>
                            </ul>
                        </div><br />
                        <div className="mb-8">
                            <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                                {customerSegmentaionsResponse.map((segment, index) => (
                                    <div
                                        key={index}
                                        className={`bg-white rounded-lg border shadow-sm ${[
                                            "border-indigo-100",
                                            "border-purple-100",
                                            "border-blue-100",
                                            "border-yellow-100",
                                            "border-orange-100",
                                            "border-red-100",
                                        ][index]
                                            }`}
                                    >
                                        <div className="p-4">
                                            <div className="flex items-center mb-2">
                                                <div
                                                    className={`h-3 w-3 rounded-full mr-2 ${[
                                                        "bg-indigo-500",
                                                        "bg-purple-500",
                                                        "bg-blue-500",
                                                        "bg-yellow-500",
                                                        "bg-orange-500",
                                                        "bg-red-500",
                                                        "bg-blue-500"
                                                    ][index]
                                                        }`}
                                                ></div>
                                                <h4 className="font-medium">
                                                    {["Champions", "Loyalists", "Potential", "New", "At Risk", "Hibernating", "Others"][index]}
                                                </h4>
                                            </div>
                                            <p className="text-xs text-gray-600 mb-1">
                                                {[
                                                    "Recent, frequent, high spend",
                                                    "Frequent, moderate spend",
                                                    "Recent, frequent, high spend",
                                                    "Recent, few purchases",
                                                    "Lapsing, high past value",
                                                    "Long inactive",
                                                ][index]}
                                            </p>
                                            <p className="text-lg font-bold">{segment?.pct_customers}</p>
                                        </div>
                                        <div class="border-t border-indigo-100 flex justify-between py-2 px-4">
                                            <p className="text-xs text-gray-500">{segment?.pct_revenue} of revenue</p>
                                            <p className="text-xs text-gray-500">${Number(segment?.revenue)?.toLocaleString('en-US')}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>


                    </div>
                )}

                {/* 🆕 CRM Tab Placeholder */}
                {activeTab === "rfm" && (
                    <div className="fade-in config-card p-6 mb-0 cstm_ResultsTest-radius rounded-none">
                        {/* <h3 className="text-lg font-medium text-gray-900 mb-1">RFM Analysis</h3>
                        <p className="text-sm text-gray-500 mb-4">
                            Recency, Frequency, Monetary analysis segments customers based on their purchase behavior.
                        </p> */}
                        <div className="grid grid-cols-3 grid-rows-2 gap-6 p-6">
                            {/* Block 1 */}
                            <div className="bg-blue-600 text-white rounded-lg shadow-lg flex flex-col items-center justify-center p-6">
                                <div className="text-lg font-semibold mb-2">Total Orders</div>
                                <div className="text-4xl font-bold">{blockValue.totalOrder?.toLocaleString('en-US')}</div>
                            </div>

                            {/* Block 2 */}
                            <div className="bg-green-600 text-white rounded-lg shadow-lg flex flex-col items-center justify-center p-6">
                                <div className="text-lg font-semibold mb-2">Total Customers</div>
                                <div className="text-4xl font-bold">{blockValue.totalCustomers?.toLocaleString('en-US')}</div>
                            </div>

                            {/* Block 3 */}
                            <div className="bg-purple-600 text-white rounded-lg shadow-lg flex flex-col items-center justify-center p-6">
                                <div className="text-lg font-semibold mb-2">Total Revenue</div>
                                <div className="text-4xl font-bold">${blockValue.totalRevenue?.toLocaleString('en-US')}</div>
                            </div>

                            {/* Block 4 */}
                            <div className="bg-red-600 text-white rounded-2xl shadow-xl p-6 w-full max-w-md">
                                <div className="flex items-center justify-between mb-4">
                                    <div className="text-lg font-semibold">💰 Highest Spent</div>
                                    <div className="text-2xl font-bold">
                                        ${blockValue.highestSpent?.toLocaleString('en-US') ?? '0'}
                                    </div>
                                </div>

                                <div className="border-t border-white/20 pt-4 mt-4 flex flex-col sm:flex-row sm:justify-between gap-4">
                                    {/* Email Block */}
                                    <div className="flex-1">
                                        <div className="text-sm text-white/80 mb-1">Customer Email</div>
                                        <div className="text-base font-medium break-all">
                                            {blockValue.highestCust?.customerEmail ?? 'N/A'}
                                        </div>
                                    </div>

                                    {/* Name Block */}
                                    <div className="flex-1">
                                        <div className="text-sm text-white/80 mb-1">Customer Name</div>
                                        <div className="text-base font-medium break-all">
                                            {blockValue.highestCust?.customer_name ?? 'N/A'}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Block 5 */}
                            <div className="bg-yellow-500 text-white rounded-lg shadow-lg flex flex-col items-center justify-center p-6">
                                <div className="text-lg font-semibold mb-2">Highest Days</div>
                                <div className="text-4xl font-bold">{blockValue.highestDays?.toLocaleString('en-US')}</div>
                            </div>

                            {/* Block 6 */}
                            <div className="bg-indigo-600 text-white rounded-lg shadow-lg flex flex-col items-center justify-center p-6">
                                <div className="text-lg font-semibold mb-2">Lowest Days</div>
                                <div className="text-4xl font-bold">{blockValue.lowestDays?.toLocaleString('en-US')}</div>
                            </div>
                        </div>

                        <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
                            <div class="flex items-start">
                                <div class="bg-indigo-100 p-3 rounded-full mr-4">
                                    <i class="fas fa-wallet text-indigo-600 text-xl"></i>
                                </div>
                                <div>
                                    <h3 class="font-medium text-gray-900 mb-1">Recency (R)
                                    </h3>
                                    <p class="text-sm text-gray-600">How recently a customer made a purchase. Customers who bought recently are more likely to respond to marketing.
                                    </p>
                                </div>
                            </div>

                            <div class="flex items-start">
                                <div class="bg-green-100 p-3 rounded-full mr-4">
                                    <i class="fas fa-shipping-fast text-green-600 text-xl"></i>
                                </div>
                                <div>
                                    <h3 class="font-medium text-gray-900 mb-1">Frequency (F)
                                    </h3>
                                    <p class="text-sm text-gray-600">How often a customer makes a purchase. Frequent buyers are more engaged and loyal to the brand.
                                    </p>
                                </div>
                            </div>

                            <div class="flex items-start">
                                <div class="bg-purple-100 p-3 rounded-full mr-4">
                                    <i class="fas fa-check-circle text-purple-600 text-xl"></i>
                                </div>
                                <div>
                                    <h3 class="font-medium text-gray-900 mb-1">Monetary (M)
                                    </h3>
                                    <p class="text-sm text-gray-600">How much money a customer spends. High-spending customers contribute most to your revenue.</p>
                                </div>
                            </div>
                        </div>

                        <br />


                        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4 px-6">
                            {/* Search Input */}
                            <input
                                type="text"
                                placeholder="Search by name, email"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                className="px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-sm w-full"
                            />

                            {/* Number Input for Recency Days */}
                            <div className="flex gap-2">


                                {/* Number Input */}
                                <input
                                    type="number"
                                    placeholder="Recency days"
                                    value={recencyFilter}
                                    onChange={(e) => setRecencyFilter(e.target.value)}
                                    className="px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-sm w-full"
                                />

                                {/* Comparison Dropdown */}
                                <select
                                    value={recencyComparison}
                                    onChange={(e) => setRecencyComparison(e.target.value)}
                                    className="px-2 py-2 border border-gray-300 rounded-md text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                >
                                    <option value="eq">= Equal to</option>
                                    <option value="ne">≠ Not equal to</option>
                                    <option value="lt">&lt; Less than</option>
                                    <option value="lte">≤ Less than or equal</option>
                                    <option value="gt">&gt; Greater than</option>
                                    <option value="gte">≥ Greater than or equal</option>
                                </select>
                            </div>

                            {/* Dropdown for Segment Filter */}
                            <select
                                value={segmentFilter}
                                onChange={(e) => setSegmentFilter(e.target.value)}
                                className="px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 text-sm w-full"
                            >
                                <option value="">All Segments</option>
                                <option value="Champion">Champions</option>
                                <option value="Loyalist">Loyalists</option>
                                <option value="Potential">Potential</option>
                                <option value="New">New</option>
                                <option value="At Risk">At Risk</option>
                                <option value="Hibernating">Hibernating</option>
                                <option value="Others">Others</option>
                            </select>
                        </div>
                        <br />
                        <div className="overflow-x-auto">
                            <table className="min-w-full divide-y divide-gray-200">
                                <thead className="bg-gray-50">
                                    <tr>
                                        {['Customer', 'RFM Score', 'Details', 'Segment'].map(header => (
                                            <th
                                                key={header}
                                                className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                            >
                                                {header}
                                            </th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody className="bg-white divide-y divide-gray-200">
                                    {paginatedData.length > 0 && paginatedData.map((cust, index) => (
                                        <tr key={index} className="hover:bg-gray-50">
                                            {/* Customer Info */}
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div className="flex items-center">
                                                    <div
                                                        className={`flex-shrink-0 h-10 w-10 bg-${cust.color}-100 rounded-full flex items-center justify-center`}
                                                    >
                                                        <span className={`text-${cust.color}-800 font-bold`}>{cust.initials}</span>
                                                    </div>
                                                    <div className="ml-4">

                                                        <div className="text-sm font-medium text-gray-900">{cust.name?.trim() == "" ? 'N/A' : cust.name}</div>
                                                        <div className="text-sm text-gray-500">{cust.email?.trim() == null ? "N/A" : cust.email}</div>
                                                    </div>
                                                </div>
                                            </td>

                                            {/* RFM Score */}
                                            <td className="px-6 py-4 whitespace-nowrap ">
                                                <div className="flex  mb-1">
                                                    <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800 mr-1">
                                                        R{cust.scores.R}
                                                    </span>
                                                    <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800 mr-1">
                                                        F{cust.scores.F}
                                                    </span>
                                                    <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-purple-100 text-purple-800">
                                                        M{cust.scores.M}
                                                    </span>
                                                </div>
                                                <div className="text-xs text-gray-500">
                                                    Total: {cust.scores.R + cust.scores.F + cust.scores.M} (R+F+M)
                                                </div>
                                            </td>

                                            {/* Details */}
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div className="text-sm text-gray-900">Recency: {cust.recency}</div>
                                                <div className="text-sm text-gray-500">
                                                    Total Spent: {cust.totalSpent} | Orders: {cust.orders}
                                                </div>
                                            </td>

                                            {/* Segment */}
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <span
                                                    className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-${cust.segmentColor}-100 text-${cust.segmentColor}-800`}
                                                >
                                                    {cust.segment}
                                                </span>
                                            </td>

                                            {/* Actions */}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <div className="flex justify-between items-center mt-4 px-6">
                                <div className="text-sm text-gray-600">
                                    Page {currentPage} of {totalPages}
                                </div>
                                <div className="space-x-2">
                                    <button
                                        onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                                        disabled={currentPage === 1}
                                        className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
                                    >
                                        Previous
                                    </button>
                                    <button
                                        onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                                        disabled={currentPage === totalPages}
                                        className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
                                    >
                                        Next
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {
                    activeTab === "snlt" && (
                        <div className="fade-in config-card p-6 mb-0 cstm_ResultsTest-radius rounded-none">
                            <div className="max-w-full">
                                <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-6">
                                    <div className="lg:col-span-3 grid grid-cols-1 md:grid-cols-3 gap-6">
                                        {/* Overall Daily Average */}
                                        <div className="bg-white rounded-lg border shadow-sm border-indigo-100 px-5 py-5">
                                            <div className="flex justify-between items-start">
                                                <div>
                                                    <h3 className="text-slate-500 text-sm font-medium">Overall Daily Average</h3>
                                                    <p className="mt-2 text-3xl font-bold text-secondary">
                                                        ${calendar_insights?.Overall_Daily_Avg?.toLocaleString('US') ?? 'N/A'}
                                                    </p>
                                                </div>
                                                <div className="bg-primary/10 p-3 rounded-full">
                                                    <i className="fas fa-chart-line text-primary text-xl"></i>
                                                </div>
                                            </div>
                                            {/* <div className="mt-6 text-sm text-slate-500 flex items-center">
                                        <span className="w-8"><i className="fas fa-long-arrow-alt-up text-positive mr-1"></i></span>
                                        <span>Baseline Metric</span>
                                    </div> */}
                                        </div>

                                        {/* Peak Weekday */}
                                        <div className="stat-card bg-gradient-to-br from-secondary to-gray-900 text-white rounded-xl shadow-sm p-6 transition-all duration-300 transform hover:shadow-lg">
                                            <div className="flex justify-between items-start">
                                                <div>
                                                    <h3 className="text-slate-300 text-sm font-medium">Peak Weekday</h3>
                                                    <p className="mt-2 text-3xl font-bold">{calendar_insights?.Peak_Weekday ?? 'N/A'}</p>
                                                </div>
                                                <div className="bg-white/20 p-3 rounded-full">
                                                    <i className="fas fa-star text-white text-xl"></i>
                                                </div>
                                            </div>
                                            <div className="mt-6 text-sm">
                                                <p>
                                                    Avg: <span className="font-bold">${calendar_insights?.Peak_Weekday_Avg?.toLocaleString('en-US') ?? 'N/A'}</span> |
                                                    <span
                                                        className={`ml-2 font-semibold ${parseFloat(calendar_insights?.Pct_Above_Overall_Weekday.replace('%', '')) >= 0
                                                            ? 'text-highlight'
                                                            : 'text-red-500'
                                                            }`}
                                                    >
                                                        <i
                                                            className={`fas mr-1 ${parseFloat(calendar_insights?.Pct_Above_Overall_Weekday.replace('%', '')) >= 0
                                                                ? 'fa-arrow-up'
                                                                : 'fa-arrow-down'
                                                                }`}
                                                        ></i>
                                                        {calendar_insights?.Pct_Above_Overall_Weekday} above overall
                                                    </span>
                                                </p>
                                            </div>

                                            
                                        </div>

                                        {/* Mid-Month (15–20) */}
                                        <div className="bg-white rounded-lg border shadow-sm border-indigo-100 px-5 py-5">
                                            <div className="flex justify-between items-start">
                                                <div>
                                                    <h3 className="text-slate-500 text-sm font-medium">Mid-Month (15-20) Avg</h3>
                                                    <p className="mt-2 text-3xl font-bold text-highlight">${calendar_insights?.Range_15_to_20_Day_Avg?.toLocaleString("US") ?? 'N/A'}</p>
                                                </div>
                                                <div className="bg-yellow-100 p-3 rounded-full">
                                                    <i className="fas fa-calendar-alt text-highlight text-xl"></i>
                                                </div>
                                            </div>
                                            {calendar_insights?.Pct_Above_Overall_15_20 && parseFloat(calendar_insights?.Pct_Above_Overall_15_20?.replace('%', '')) !== 0 && (
                                                <div className="mt-6 flex items-center">
                                                    {/* <span
                                                        className={`font-bold ${calendar_insights?.Pct_Above_Overall_15_20 >= 0
                                                            ? 'text-positive'  // green
                                                            : 'text-red-500'   // red
                                                            }`}
                                                    >
                                                        <i
                                                            className={`fas ${calendar_insights?.Pct_Above_Overall_15_20 >= 0
                                                                ? 'fa-arrow-up'
                                                                : 'fa-arrow-down'
                                                                } mr-1`}
                                                        ></i>
                                                        {calendar_insights?.Pct_Above_Overall_15_20}
                                                    </span> */}
                                                    {/* <span className="text-slate-500 text-sm ml-2">above overall average</span> */}
                                                </div>
                                            )}

                                        </div>

                                        {/* Seasonal Metrics */}
                                        {/* <div className="bg-white rounded-lg border shadow-sm border-indigo-100 px-5 py-5">
                                            <div>
                                                <h3 className="text-slate-500 text-sm font-medium">Seasonal Metrics</h3>
                                            </div>
                                            <div className="mt-4">
                                                <div className="flex justify-between items-center py-3 border-b border-slate-100">
                                                    <div className="flex items-center">
                                                        <i className="fas fa-gift text-positive mr-3"></i>
                                                        <span>Holiday Average:</span>
                                                    </div>
                                                    <span className="font-bold">${calendar_insights?.Holiday_Avg.toLocaleString("US") ?? 'N/A'}</span>
                                                </div>
                                                <div className="flex justify-between items-center py-3 border-b border-slate-100">
                                                    <div className="flex items-center">
                                                        <i className="fas fa-calendar text-slate-400 mr-3"></i>
                                                        <span>Rest Average:</span>
                                                    </div>
                                                    <span className="font-bold">${calendar_insights?.Rest_Avg?.toLocaleString('en-US') ?? 'N/A'}</span>
                                                </div>
                                                <div className="flex justify-between items-center pt-3">
                                                    <div className="flex items-center">
                                                        <i className="fas fa-chart-bar text-primary mr-3"></i>
                                                        <span>Seasonal Increase:</span>
                                                    </div>
                                                    <span
                                                        className={`font-bold ${calendar_insights?.Pct_Seasonal_Increase > 0 ? 'text-positive' : 'text-red-500'}`}
                                                    >
                                                        {calendar_insights?.Pct_Seasonal_Increase ?? 'N/A'}
                                                    </span>
                                                </div>
                                            </div>
                                        </div> */}
                                    </div>

                                    {/* Right Column Summary */}
                                    <div style={{display:"none"}}>
                                        <div className="bg-white rounded-lg border shadow-sm border-indigo-100 px-5 py-5">
                                            <h3 className="text-lg font-semibold text-secondary mb-4">Performance Summary</h3>
                                            <div className="space-y-4">
                                                <div className="flex gap-4">
                                                    <div className="flex-shrink-0">
                                                        <div className="bg-blue-50 p-3 rounded-lg">
                                                            <i className="fas fa-bolt text-primary text-xl"></i>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <h4 className="font-medium">Peak Performer</h4>
                                                        <p className="text-slate-500 text-sm mt-1">
                                                            {calendar_insights?.Peak_Weekday ?? 'N/A'}s consistently show the highest demand at <span className="font-bold">{calendar_insights?.Pct_Above_Overall_Weekday ?? 'N/A'} above average</span>
                                                        </p>
                                                    </div>
                                                </div>

                                                <div className="flex gap-4">
                                                    <div className="flex-shrink-0">
                                                        <div className="bg-yellow-50 p-3 rounded-lg">
                                                            <i className="fas fa-calendar-alt text-highlight text-xl"></i>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <h4 className="font-medium">Mid-Month Surge</h4>
                                                        <p className="text-slate-500 text-sm mt-1">Days 15-20 see a <span className="font-bold">{calendar_insights?.Pct_Above_Overall_15_20 ?? 'N/A'}</span> driven by payroll cycles</p>
                                                    </div>
                                                </div>

                                                <div className="flex gap-4">
                                                    <div className="flex-shrink-0">
                                                        <div className="bg-green-50 p-3 rounded-lg">
                                                            <i className="fas fa-gift text-positive text-xl"></i>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <h4 className="font-medium">Seasonal Potential</h4>
                                                        <p className="text-slate-500 text-sm mt-1">Holiday periods drive <span className="font-bold">{calendar_insights?.Pct_Seasonal_Increase ?? 'N/A'} growth</span> over baseline periods</p>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Recommendations (static text) */}
                                            {/* <div className="mt-6">
                                                <h4 className="font-medium mb-2">Recommendations</h4>
                                                <ul className="text-sm text-slate-600 space-y-2">
                                                    <li className="flex items-start">
                                                        <i className="fas fa-check-circle text-positive mr-2 mt-1"></i>
                                                        <span>Increase staffing on peak days and mid-month windows</span>
                                                    </li>
                                                    <li className="flex items-start">
                                                        <i className="fas fa-check-circle text-positive mr-2 mt-1"></i>
                                                        <span>Run offers around payroll & holidays</span>
                                                    </li>
                                                    <li className="flex items-start">
                                                        <i className="fas fa-check-circle text-positive mr-2 mt-1"></i>
                                                        <span>Build seasonal campaigns based on holiday uplift</span>
                                                    </li>
                                                </ul>
                                            </div> */}
                                        </div>
                                    </div>
                                </div>

                                {/* Performance Metrics Table */}
                                {/* <div className="bg-white rounded-xl shadow-sm overflow-x-auto" >
                                    <h3 className="text-lg font-semibold text-secondary mb-4">Performance Metrics Detail</h3>
                                    <table className="w-full text-sm">
                                        <thead>
                                            <tr className="border-b border-slate-200 text-left">
                                                <th className="py-3 px-4 text-slate-500 font-medium">Metric</th>
                                                <th className="py-3 px-4 text-slate-500 font-medium">Value</th>
                                                <th className="py-3 px-4 text-slate-500 font-medium">Change From Overall</th>
                                                <th className="py-3 px-4 text-slate-500 font-medium">Insight</th>
                                            </tr>
                                        </thead>
                                        <tbody className="divide-y divide-slate-100">
                                            <tr>
                                                <td className="py-3 px-4 font-medium">Overall Daily Average</td>
                                                <td className="py-3 px-4">${calendar_insights?.Overall_Daily_Avg?.toLocaleString('en-US') ?? 'N/A'}</td>
                                                <td className="py-3 px-4 text-slate-500">N/A</td>
                                                <td className="py-3 px-4 text-slate-500">Baseline metric</td>
                                            </tr>
                                            <tr>
                                                <td className="py-3 px-4 font-medium">Peak Weekday Avg ({calendar_insights?.Peak_Weekday ?? '-'})</td>
                                                <td className="py-3 px-4">${calendar_insights?.Peak_Weekday_Avg?.toLocaleString('en-US') ?? 'N/A'}</td>
                                                <td
                                                    className={`py-3 px-4 font-semibold ${calendar_insights?.Pct_Above_Overall_Weekday &&
                                                        parseFloat(calendar_insights.Pct_Above_Overall_Weekday.replace('%', '')) >= 0
                                                        ? 'text-green-600'
                                                        : 'text-red-500'
                                                        }`}
                                                >
                                                    {calendar_insights?.Pct_Above_Overall_Weekday ?? 'N/A'}
                                                </td>
                                                <td className="py-3 px-4"><i className="fas fa-exclamation-circle text-highlight mr-1"></i> Highest day</td>
                                            </tr>
                                            <tr>
                                                <td className="py-3 px-4 font-medium">15–20 Day Avg</td>
                                                <td className="py-3 px-4">${calendar_insights?.Range_15_to_20_Day_Avg?.toLocaleString('en-US') ?? 'N/A'}</td>
                                                <td
                                                    className={`py-3 px-4 font-semibold ${calendar_insights?.Pct_Above_Overall_15_20 &&
                                                        parseFloat(calendar_insights.Pct_Above_Overall_15_20.replace('%', '')) >= 0
                                                        ? 'text-green-600'
                                                        : 'text-red-500'
                                                        }`}
                                                >
                                                    {calendar_insights?.Pct_Above_Overall_15_20 ?? 'N/A'}
                                                </td>
                                                <td className="py-3 px-4">Mid-month surge</td>
                                            </tr>
                                            <tr>
                                                <td className="py-3 px-4 font-medium">Holiday Average</td>
                                                <td className="py-3 px-4">${calendar_insights?.Holiday_Avg?.toLocaleString('en-US') ?? 'N/A'}</td>
                                                <td className="py-3 px-4">—</td>
                                                <td className="py-3 px-4"><i className="fas fa-star text-highlight mr-1"></i> Opportunity window</td>
                                            </tr>
                                            <tr>
                                                <td className="py-3 px-4 font-medium">Rest Average</td>
                                                <td className="py-3 px-4">${calendar_insights?.Rest_Avg?.toLocaleString('en-US') ?? 'N/A'}</td>
                                                <td className="py-3 px-4">—</td>
                                                <td className="py-3 px-4">Base period</td>
                                            </tr>
                                            <tr>
                                                <td className="py-3 px-4 font-medium">Seasonal Increase</td>
                                                <td className="py-3 px-4">—</td>

                                                <td
                                                    className={`py-3 px-4 font-semibold ${calendar_insights?.Pct_Seasonal_Increase &&
                                                        parseFloat(calendar_insights.Pct_Seasonal_Increase.replace('%', '')) >= 0
                                                        ? 'text-green-600'
                                                        : 'text-red-500'
                                                        }`}
                                                >
                                                    {calendar_insights?.Pct_Seasonal_Increase ?? 'N/A'}
                                                </td>


                                                <td className="py-3 px-4"><i className="fas fa-chart-line text-positive mr-1"></i> Seasonal trend</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div> */}
                            </div>
                        </div>



                    )
                }

                {/* {
                    activeTab === "k-means" &&
                    <Kmeans />
                } */}
                <div style={{ display: activeTab === "k-means" ? 'block' : 'none' }}>
                    <Kmeans rfmResponsePrev={rfmResponse} />
                </div>
                
                <div style={{ display: activeTab === "k-means-clustering" ? 'block' : 'none' }}>
                    <KmeansClustering  />
                </div>
            </div>
        </main>

    );
});

export default Rfm;
